// Global variable to track active observers
let activeObservers = new Map();
let loadedProductIds = new Set(); // Track which items have already been loaded

const loadItems = (button) => {
	const totalPages = parseInt($("[data-total-pages]").val());
	let currentPage = parseInt($("[data-current-page]").val());

	currentPage = currentPage + 1;
	const nextUrl = $("[data-next-url]")
		.val()
		.replace(/page=[0-9]+/, "page=" + currentPage);
	
	$("[data-current-page]").val(currentPage);

	// Prevent multiple simultaneous requests
	if (button.hasAttribute("disabled")) {
		return;
	}

	button.setAttribute("disabled", "");
	button.classList.add("loading");

	$.ajax({
		url: nextUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			// Parse the response
			const $responseContent = $(responseHTML);
		const $newProducts = $responseContent.find(".load-more-grid").children();
			
			// Extract only new, unique product cards
			const newProductsToAdd = [];
			$newProducts.each(function() {
				const $productCard = $(this);
				
			// Try to extract a stable item ID from various possible sources
			let productId = null;
				
			// Look for product links, IDs, or handles in the card
				const $productLink = $productCard.find('a[href*="/products/"]').first();
				if ($productLink.length) {
					const href = $productLink.attr('href');
					const matches = href.match(/\/products\/([^?&#]+)/);
					if (matches) {
						productId = matches[1]; // This will be the product handle
					}
				}
			
			// Look for article links when on blog pages
			if (!productId) {
				const $articleLink = $productCard.find('a[href*="/blogs/"]').first();
				if ($articleLink.length) {
					const href = $articleLink.attr('href');
					const matches = href.match(/\/blogs\/[^/]+\/([^?&#]+)/);
					if (matches) {
						productId = matches[1]; // Article handle
					}
				}
			}
				
			// Alternative: look for data attributes that might contain item info
				if (!productId) {
					const $productElement = $productCard.find('[data-product-id], [data-product-handle]').first();
					if ($productElement.length) {
						productId = $productElement.attr('data-product-id') || $productElement.attr('data-product-handle');
					}
				}
				
			// Alternative: look for product form or other identifying elements
				if (!productId) {
					const $productForm = $productCard.find('form[action*="/cart/add"]').first();
					if ($productForm.length) {
						const $productIdInput = $productForm.find('input[name="id"]').first();
						if ($productIdInput.length) {
							productId = $productIdInput.val();
						}
					}
				}
				
				// If we still can't find a product ID, use the entire HTML as a fallback identifier
				if (!productId) {
					// Create a simple hash of the product card content
					const cardText = $productCard.text().trim().replace(/\s+/g, ' ');
					productId = 'card_' + cardText.substring(0, 50);
				}
				
				// Only add if we haven't seen this product before
				if (productId && !loadedProductIds.has(productId)) {
					loadedProductIds.add(productId);
					newProductsToAdd.push($productCard[0].outerHTML);
				}
			});
			
			// Append only the new, unique products
			if (newProductsToAdd.length > 0) {
				$(".load-more-grid").append(newProductsToAdd.join(''));
				console.log(`Added ${newProductsToAdd.length} new products from page ${currentPage}`);
			} else {
				console.log(`No new products found on page ${currentPage} - all products may already be loaded`);
			}
			
			colorSwatches();
		},
		complete: function () {
			if (currentPage <= totalPages) {
				const scrollData = document.querySelector(".infinite-scroll__data");
				if (scrollData && currentPage != totalPages) {
					// Update the next URL for the next page
					const nextPageUrl = $("[data-next-url]")
						.val()
						.replace(/page=[0-9]+/, "page=" + (currentPage + 1));
					
					scrollData.querySelector("input[data-next-url]").value = nextPageUrl;
					scrollData.querySelector("input[data-current-page]").value = currentPage;
					
					// Re-enable infinite scroll for the next page
					checkVisibility();
				}
				button.removeAttribute("disabled");
				button.classList.remove("loading");
				if (currentPage >= totalPages) {
					button.remove();
					// Clean up any remaining observers
					cleanupObservers();
				}
			}
		},
		error: function(xhr, status, error) {
			console.error('Error loading more products:', error);
			button.removeAttribute("disabled");
			button.classList.remove("loading");
		}
	});
};

const cleanupObservers = () => {
	// Disconnect and remove all active observers
	activeObservers.forEach((observer, element) => {
		observer.disconnect();
	});
	activeObservers.clear();
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	
	// Clean up existing observers first
	cleanupObservers();
	
	spinnerList.forEach((spinner) => {
		// Skip if this spinner already has an observer
		if (activeObservers.has(spinner)) {
			return;
		}

		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !spinner.hasAttribute("disabled")) {
					// Immediately disconnect this observer to prevent duplicate triggers
					sectionObserver.disconnect();
					activeObservers.delete(spinner);
					loadItems(spinner);
				}
			});
		}, {
			// Add a small threshold to prevent premature triggering
			threshold: 0.1,
			rootMargin: '50px'
		});

		// Store the observer reference
		activeObservers.set(spinner, sectionObserver);
		sectionObserver.observe(spinner);
	});
};

// Initialize product tracking with existing products on page load
const initializeProductTracking = () => {
	const existingProducts = document.querySelectorAll(".load-more-grid > *");
	existingProducts.forEach(productCard => {
		// Extract product ID using the same logic as in loadItems
		let productId = null;
		
		const productLink = productCard.querySelector('a[href*="/products/"]');
		if (productLink) {
			const href = productLink.getAttribute('href');
			const matches = href.match(/\/products\/([^?&#]+)/);
			if (matches) {
				productId = matches[1];
			}
		}
		
		if (!productId) {
			const articleLink = productCard.querySelector('a[href*="/blogs/"]');
			if (articleLink) {
				const href = articleLink.getAttribute('href');
				const matches = href.match(/\/blogs\/[^/]+\/([^?&#]+)/);
				if (matches) {
					productId = matches[1];
				}
			}
		}
		
		if (!productId) {
			const productElement = productCard.querySelector('[data-product-id], [data-product-handle]');
			if (productElement) {
				productId = productElement.getAttribute('data-product-id') || productElement.getAttribute('data-product-handle');
			}
		}
		
		if (!productId) {
			const productForm = productCard.querySelector('form[action*="/cart/add"]');
			if (productForm) {
				const productIdInput = productForm.querySelector('input[name="id"]');
				if (productIdInput) {
					productId = productIdInput.value;
				}
			}
		}
		
		if (!productId) {
			const cardText = productCard.textContent.trim().replace(/\s+/g, ' ');
			productId = 'card_' + cardText.substring(0, 50);
		}
		
		if (productId) {
			loadedProductIds.add(productId);
		}
	});
	
	console.log(`Initialized tracking for ${loadedProductIds.size} existing products`);
};

function loadMore() {
	// Initialize product tracking first
	initializeProductTracking();
	
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
}

// Reset product tracking when filters are applied (facets change the entire grid)
const resetProductTracking = () => {
	loadedProductIds.clear();
	console.log('Product tracking reset for new filter/sort');
};

// Listen for facet changes to reset tracking
document.addEventListener('DOMContentLoaded', function() {
	// Watch for changes in the product grid that might indicate filtering
	const productGrid = document.getElementById('product-grid');
	const loadMoreGrid = document.querySelector('.load-more-grid');
	const gridRoot = productGrid || loadMoreGrid;
	if (gridRoot) {
		const gridObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				// If the entire grid content was replaced (like during filtering)
				if (mutation.type === 'childList' && mutation.target === gridRoot) {
					// Check if this looks like a complete replacement rather than an append
					const removedNodes = Array.from(mutation.removedNodes);
					const addedNodes = Array.from(mutation.addedNodes);
					
					// If we removed product cards and added different ones, it's likely a filter change
					if (removedNodes.some(node => node.nodeType === 1)) {
						resetProductTracking();
						// Re-initialize with the new products
						setTimeout(initializeProductTracking, 100);
					}
				}
			});
		});
		
		gridObserver.observe(gridRoot, {
			childList: true,
			subtree: true
		});
	}
});

// Clean up observers when page is unloaded
window.addEventListener('beforeunload', cleanupObservers);

(function () {
	loadMore();
})();
